export default __webpack_public_path__ + "static/media/azuki.79494b7f.png";